module.exports = __webpack_public_path__ + "img/back.4722257873f.598a4700.jpg";